import { LOCAL_STORAGE_KEYS, TOKEN_BY_ADDRESS } from 'consts';
import { TokenInfo } from 'types';
import { Address } from 'viem';

import { INITIAL_FIXED_TOKENS } from './consts';

const FIXED_TOKENS_KEY = LOCAL_STORAGE_KEYS.FIXED_TOKENS;
const CUSTOM_TOKENS_KEY = LOCAL_STORAGE_KEYS.CUSTOM_TOKENS;

export const getFixedTokens = (chainId: number): Address[] => {
  try {
    const tokensMapStr = String(localStorage.getItem(FIXED_TOKENS_KEY));
    const tokensMap = JSON.parse(tokensMapStr);
    if (tokensMap[chainId].length === 0) return [];

    const tokens = tokensMap[chainId].filter(
      (address: Address) => !!TOKEN_BY_ADDRESS[chainId][address]
    );
    if (tokens.length === 0) {
      return INITIAL_FIXED_TOKENS[chainId];
    }
    return tokens;
  } catch {
    return INITIAL_FIXED_TOKENS[chainId];
  }
};

export const saveFixedTokens = (chainId: number, tokens: Address[]) => {
  try {
    const tokensMapStr = localStorage.getItem(FIXED_TOKENS_KEY) || '{}';
    const tokensMap = JSON.parse(tokensMapStr);
    tokensMap[chainId] = tokens;
    localStorage.setItem(FIXED_TOKENS_KEY, JSON.stringify(tokensMap));
  } catch {
    localStorage.setItem(FIXED_TOKENS_KEY, JSON.stringify({ [chainId]: tokens }));
  }
};

export const saveCustomTokens = (chainId: number, tokens: TokenInfo[]) => {
  try {
    const tokensMapStr = localStorage.getItem(CUSTOM_TOKENS_KEY) || '{}';
    const tokensMap = JSON.parse(tokensMapStr);
    tokensMap[chainId] = tokens;
    localStorage.setItem(CUSTOM_TOKENS_KEY, JSON.stringify(tokensMap));
  } catch {
    localStorage.setItem(CUSTOM_TOKENS_KEY, JSON.stringify({ [chainId]: tokens }));
  }
};
